<template>
    <div class="container">
        
        <el-form ref="searchForm" :model="searchData" inline>
        <el-form-item label="下一步">
            <el-select v-model="next" size="mini" multiple>
                <el-option
                    v-for="(s, key) in setting"
                    :key="key"
                    :label="s.name"
                    :value="key"
                />
            </el-select>
        </el-form-item>
        <el-form-item label="序号">
            <el-input v-model.number="searchData.central_id" size="mini" />
        </el-form-item>
        <el-form-item label="微信昵称">
            <el-input v-model="searchData.module.weChat.nickname" size="mini" />
        </el-form-item>
        <el-form-item>
            <el-button size="mini" type="primary"  @click="handlerSearch">
            查找
            </el-button>
        </el-form-item>
        </el-form>
        <el-table 
            :data="circuitList" 
            v-loading="loading"
        >
            <el-table-column prop="id" label="ID" />
            <el-table-column prop="classify" label="分类" />
            <el-table-column label="头像" >
                <template slot-scope="{row}">
                    <el-image style="width: 50px;" :src="row.weChat.avatar"/>
                </template>
            </el-table-column>
            <el-table-column prop="weChat.nickname" label="昵称" />
            <el-table-column prop="central_id" label="序号" />
            <el-table-column prop="time" label="Time" />
            <el-table-column prop="nextS" label="下一步" />
            <el-table-column prop="id" label="处理">
                <template slot-scope="s">
                    <el-button size="mini" @click="proc(s.row)">处理</el-button>
                </template>
            </el-table-column>
        </el-table>
        <page-bar
            :currentPageCount="currentPazeCount"
            @page-index="onPageIndex"
            @page-changed="onPageChange"
            @pageSize="onPageSize"
            />
    </div>
</template>
<script>
import PageBar from "../ui/PageBar";
import request from "../../api/request"

const LOCAL_STORAGE_KEY = 'ERP_NEXT'

export default {
    components: { PageBar },
    data: () => ({
        loading: false,
        setting: {},
        list: [],
        currentPageIndex: 1,
        currentRange: [0, 10],
        currentPageSize: 10,
        currentPazeCount:0,
        searchData: {
            module: {
                weChat: {
                    nickname: ''
                }
            },
            central_id: null,
            next: []
        },
        next: []
    }),
    created() {
        this.getSetting()
    },
    computed:{
        circuitList: function () {
            if (this.setting && this.list) {
                for(const item of this.list) {
                    item.nextS = this.setting[ item.next ].name
                }
                return this.list
            } else {
              return []
            }
        }
    },
    watch: {
        next(value) {
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(value))
        }
    },
    methods: {
        handlerSearch() {
            this.searchData.next = this.next
            this.getList()
        },
        getSetting() {
            request.erp.post('circuit_setting_get').then(resp => {
                if (resp.status === 0) {
                    this.setting = resp.data || {}
                }
                if (!localStorage.getItem(LOCAL_STORAGE_KEY)) {
                    this.next = Object.keys(this.setting)
                    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this.next))
                } else {
                    this.next = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY))
                }
                
                this.getList()
            })
        },
        getList() {
            const args = {
                filter: {}
            }
            if (this.searchData.next.length > 0) {
                args.filter.next = this.searchData.next
            }
            if (this.searchData.central_id) {
                args.filter.central_id = this.searchData.central_id
            }
            if (this.searchData.module.weChat.nickname) {
                args.module = {
                    weChat: {
                        nickname: this.searchData.module.weChat.nickname
                    }
                }
            }
            args.range = this.currentRange || [0, 10]
            request.erp.post('circuit_list', args).then(resp => {
                this.list = resp.data.list || []
                this.currentPazeCount = this.list.length
            })
        },
        proc(info) {
            this.$router.push(`/erp/edit/${info.id}/${info.next}/${info.central_id}/${info.classify}`)
        },
        onPageIndex(data) {
            this.currentPageIndex = data
        },
        onPageChange(data) {
            this.currentRange = data
            this.getList()
        },
        onPageSize(data) {
            this.currentPageSize = data
        }
    }
}
</script>
